import { Component, OnDestroy, OnInit, ViewEncapsulation,ChangeDetectorRef, AfterViewInit  } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';

@Component({
    selector     : 'fuse-progress-bar',
    templateUrl  : './progress-bar.component.html',
    styleUrls    : ['./progress-bar.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class FuseProgressBarComponent implements OnInit,OnDestroy,AfterViewInit 
{
    bufferValue: number;
    //mode: 'determinate' | 'indeterminate' | 'buffer' | 'query';
    value: number;
    visible: boolean;
    show:boolean = false;
    // Private
    private _unsubscribeAll: Subject<any>;

    /**
     * Constructor
     *
     * @param {FuseProgressBarService} _fuseProgressBarService
     */
    constructor(private cdr: ChangeDetectorRef,
        private _fuseProgressBarService: FuseProgressBarService
    )
    {
        // Set the defaults

        // Set the private defaults
        this._unsubscribeAll = new Subject();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit()
    {
        // Subscribe to the progress bar service properties

        // Buffer value
        this._fuseProgressBarService.showLoaderEmitter
        .pipe(takeUntil(this._unsubscribeAll))
        .subscribe((mode) => {
            this.show = mode;
            this.cdr.detectChanges();
        });
        this._fuseProgressBarService.visible
        .pipe(takeUntil(this._unsubscribeAll))
        .subscribe((visible) => {
            this.visible = visible;
        });

        // this._fuseProgressBarService.showLoaderEmitter.subscribe((mode)=>{
            
        //     this.show = mode;

			
        // });
        // Mode
        

    }

    ngAfterViewInit() {
       // this.message = 'all done loading :)'
        this.cdr.detectChanges();
      }

    /**
     * On destroy
     */
    // ngOnDestroy(): void
    // {
    //     // Unsubscribe from all subscriptions
    //     this._unsubscribeAll.next();
    //     this._unsubscribeAll.complete();
    // }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------
    ngOnDestroy() :void{
       this.cdr.detectChanges();
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
      }
}
